<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="添加材料" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="625px">
    <div class="dialog__container">
      <el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
        label-width="70px">
        <el-form-item label="配件名称：" prop="materialName" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.materialName" placeholder="请输入配件名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="成本价：" prop="costAmount" class="input-with-col2 mr0">
          <el-input size="mini" type="number" v-model.trim="form.costAmount" placeholder="请输入成本价" clearable></el-input>
        </el-form-item>
        <el-form-item label="售价：" prop="salesAmount" class="input-with-col2 mr0">
          <el-input size="mini" type="number" v-model.trim="form.salesAmount" placeholder="请输入售价" clearable></el-input>
        </el-form-item>
        <el-form-item label="货位编号：" prop="shelfNumber" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.shelfNumber" placeholder="请输入货位编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="规格：" prop="specification" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.specification" placeholder="请输入规格" clearable></el-input>
        </el-form-item>
        <el-form-item label="数量：" prop="amount" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.amount" placeholder="请输入数量" type="number" clearable></el-input>
        </el-form-item>
        <el-form-item label="使用单位：" prop="useUnit" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.useUnit" placeholder="请输入使用单位" clearable></el-input>
        </el-form-item>
        <el-form-item label="供应商：" prop="supplier" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.supplier" placeholder="请输入供应商" clearable></el-input>
        </el-form-item>
        <el-form-item label="附属图片：" prop="imageList" class="mr0">
          <el-upload class="upload-demo" :on-preview="handlePreview" :on-remove="handleRemove" action="fakeaction"
            :on-success="handleAvatarSuccess" :file-list="fileList" list-type="picture" :headers="token"
            :http-request="uploadFileRequest">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {
    saveMaterialInfo,
    uploadFile
  } from '@/api/Material'
  import cookies from '../../../libs/util.cookies'
  export default {
    data() {
      return {
        token: {
          Authorization: "Bearer " + cookies.get('token')
        },
        fileList: [],
        form: {
          materialName: '',
          shelfNumber: '',
          specification: '',
          amount: '',
          useUnit: '',
          supplier: '',
          costAmount: '',
          salesAmount: '',
          imageList: []
        },
        rules: {
          materialName: [{
            required: true,
            message: "请输入配件名称",
            trigger: "blur",
          }, ],
          costAmount: [{
            required: true,
            message: "请输入成本价",
            trigger: "blur",
          }, ],
          salesAmount: [{
            required: true,
            message: "请输入售价",
            trigger: "blur",
          }, ],
        },
        loadBtn: false,
      };
    },
    created() {},
    methods: {
      uploadFileRequest(params) {
        const file = params.file;
        console.log(file)
        // 根据后台需求数据格式
        const form = new FormData();
        // 文件对象
        form.append("file", file);
        console.log(form)
        uploadFile(form).then(response => {
            if (response.code === 200) {
              this.$message.success('上传成功')
              let data = response.data;
              this.fileList.push({
                name: data.name,
                url: data.url
              });
            } else {
              this.$message.error('上传失败，请联系管理员')
            }
          })
          .catch(() => {
            this.$message.error('上传失败，请联系管理员')
          });
      },
      handleRemove(file, fileList) {
        console.log(file);
        console.log(this.fileList);
        // 2.从pics数组中，找到图片对应的索引值
        const index = this.fileList.findIndex(x => x.url === file.url);
        console.log(index)
        // 3.调用splice方法，移除图片信息
        this.fileList.splice(index, 1)
      },
      handlePreview(file) {
        console.log(file);
      },
      handleAvatarSuccess(response, file, fileList) {
        if (response.code === 200) {
          this.$message.success('上传成功')
          let data = response.data;
          this.fileList.push({
            name: data.name,
            url: data.url
          });
        } else {
          this.$message.error('上传失败，请联系管理员')
        }
      },
      handleBeforeClose(done) {
        this.$emit("cancel");
        done();
      },
      handleCancel() {
        this.$emit("cancel");
      },
      async handleConfirm() {
        if (this.loadBtn) return;
        let fileList = this.fileList;
        console.log(fileList);
        let imageUrlList = fileList.map(function(item) {
          return item.url;
        });
        this.$refs["form"].validate(async (valid) => {

          if (valid) {
            this.loadBtn = true;
            const params = {
              ...this.form
            }

            params.imageList = imageUrlList;
            const res = await saveMaterialInfo(params);
            if (res.code === 200) {
              this.$message.success("添加成功");
              this.$emit("confirm");
            }
            this.loadBtn = false;
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/MaterialManagement/components/AddCause.vue